export default {

    data(){

        return {

            parent_carrier : '',
            carrier        : '',
            carriers       : []
        }
    },

    computed: {

        carrier_query_string(){

            if( this.carrier_preselect ) return this.carrier_preselect;

            let carrier_filter = '';

            if( this.parent_carrier != '' ){

                carrier_filter = this.carriers.map( carrier => {

                    if( carrier.parent_carrier && carrier.parent_carrier.id == this.parent_carrier ){

                        return carrier.id;
                    }
                }).filter( val => val !== undefined );
            }

            if( this.carrier != '' ) carrier_filter = this.carrier;

            return carrier_filter;
        }
    },

    methods: {

        async fetchCarriers() {

            axios.get( '/business/carriers?json=1&active=1' )
                .then( ({ data }) => {

                    this.carriers = data;
                })
                .catch( e => {});
        },
    },

    watch: {

        carrier( val ){

            if( val != '' ) this.parent_carrier = '';
        },
        parent_carrier( val ){

            if( val != '' ) this.carrier = '';
        }
    },

    async created(){

        if( !this.carrier_preselect ) await this.fetchCarriers();
    }
}